// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteConfigForm-commonHeaderAdmin-hX8lC {
	position: fixed !important;
}

.SiteConfigForm-adminLayout-K5Fdm {
	padding-top: 64px !important;
}

.SiteConfigForm-box-h6Svx h2 {
	font-size: 21px;
	font-weight: 600;
}

.SiteConfigForm-exportLink-tDDHR {
	margin-bottom: -29px;
}

.SiteConfigForm-blockCenter-SF2mA {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.SiteConfigForm-panelHeader-WyFrY {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.SiteConfigForm-currencyselect-eBU0F {
	width: 100%;
	margin-right: 0px;
}

.SiteConfigForm-panelHeader-WyFrY {
	overflow: hidden;
	position: relative;
}

.SiteConfigForm-mar0-lqYAz {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.SiteConfigForm-blockCenter-SF2mA {
		padding: 0px;
	}

	.SiteConfigForm-panelHeader-WyFrY {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.SiteConfigForm-sideAdminPageWrapper-aiNtK {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.SiteConfigForm-panelHeader-WyFrY {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.SiteConfigForm-table-Jp0Vj {
	display: table;
}

.SiteConfigForm-tableRow-SqeNW {
	display: table-row;
}

.SiteConfigForm-tableCell-QViPt {
	display: table-cell;
	float: none;
}

.SiteConfigForm-formGroup-wRZ3W {
	margin-bottom: 6px;
}

.SiteConfigForm-select-tMqVV {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.SiteConfigForm-noMargin-YgEco {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.SiteConfigForm-exportLink-tDDHR {
	padding-top: 10px;
	padding-right: 10px;
}

.SiteConfigForm-labelTextNew-wEh3n {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.SiteConfigForm-displayInline-Al0vM {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.SiteConfigForm-btnUPdate-x7B16 {
	display: inline-block;
}

.SiteConfigForm-btnModalDelete-r3up9 {
	display: inline-block;
	margin-left: 15px;
}

.SiteConfigForm-radioBtn-Ikm3Y {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.SiteConfigForm-backgroundImg-Jv3vA {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.SiteConfigForm-btnUPdate-x7B16 {
		display: block;
		margin-bottom: 12px;
	}

	.SiteConfigForm-btnModalDelete-r3up9 {
		display: block;
		margin-left: 0px;
	}

	.SiteConfigForm-btnWidth-RTQIT {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.SiteConfigForm-bannerImageBg-KnsQ_ {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.SiteConfigForm-bannerDelete-wYYk5 {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.SiteConfigForm-modalRoot-nuYmE {
	padding: 32px;
}

.SiteConfigForm-modalBorderBottom-rWCDL {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.SiteConfigForm-logInModalBody-pTI2T {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.SiteConfigForm-exportSection-PccDI {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.SiteConfigForm-exportSectionGridSub-McLGt {
	grid-template-columns: 50% 49% !important;
}

.SiteConfigForm-exportText-r9dFn {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.SiteConfigForm-exportLinkImg-wPBnr {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.SiteConfigForm-vtrMiddle-lh_iI {
	vertical-align: middle;
}

.SiteConfigForm-exportImg-iPjBx {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.SiteConfigForm-profileViewlabel-G7VKe {
	display: inline-block;
	width: 38%
}

.SiteConfigForm-profileViewMainContent-tcfEX {
	display: inline-block;
	width: 62%;
}

.SiteConfigForm-profileViewMain-jOM7x {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.SiteConfigForm-profileViewInner-Tcql8 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.SiteConfigForm-profileImageSection-rCJ5C {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.SiteConfigForm-lastviewInner-eMXPO {
	padding: 10px;
}

.SiteConfigForm-whyHostHoriLine-frJxn {
	margin: 30px 0;
}

.SiteConfigForm-tableGrid-iQeff {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.SiteConfigForm-headingContent-BL73e {
	font-size: 18px;
	font-weight: 500;
}

.SiteConfigForm-refundTextColor-nunXM {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.SiteConfigForm-dividerLine-OdLDp {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.SiteConfigForm-smallContent-vS4WV {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.SiteConfigForm-sideAdminPageWrapper-aiNtK {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.SiteConfigForm-sideAdminPageWrapper-aiNtK {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.SiteConfigForm-exportSection-PccDI {
		grid-template-columns: 100%;
	}

	.SiteConfigForm-exportSectionGridSub-McLGt {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.SiteConfigForm-profileViewlabel-G7VKe {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SiteConfigForm-profileViewMainContent-tcfEX {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.SiteConfigForm-ChangeToUpperCase-SvoBs {
	text-transform: uppercase
}

.SiteConfigForm-noBorder-pN360 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.SiteConfigForm-siteAdminHeading-dQou5 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.SiteConfigForm-siteAdminSubHeading-LalRJ {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.SiteConfigForm-adminFormDivider-mM4t8 {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.SiteConfigForm-errorMessage-mwOyT {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.SiteConfigForm-panelHeader-WyFrY {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.SiteConfigForm-formGroup-wRZ3W {
  margin-bottom: 6px;
}

.SiteConfigForm-select-tMqVV {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.SiteConfigForm-labelText-mFZem {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.SiteConfigForm-space1-B6h_o {
	margin-bottom: 6px !important;
}

.SiteConfigForm-space2-f3YjS {
	margin-bottom: 12px !important;
}

.SiteConfigForm-space3-fw160 {
	margin-bottom: 18px !important;
}

.SiteConfigForm-space4-EV3OY {
	margin-bottom: 24px !important;
}

.SiteConfigForm-space5-mVFe4 {
	margin-bottom: 30px !important;
}

.SiteConfigForm-space6-ewCaG {
	margin-bottom: 36px !important;
}

.SiteConfigForm-space7-gP_pc {
	margin-bottom: 42px !important;
}

.SiteConfigForm-spaceTop8-z0fwZ {
	margin-bottom: 48px !important;
}

.SiteConfigForm-spaceTop1-ht3f7 {
	margin-top: 6px !important;
}

.SiteConfigForm-spaceTop2-VEK6q {
	margin-top: 12px !important;
}

.SiteConfigForm-spaceTop3-STmrH {
	margin-top: 18px !important;
}

.SiteConfigForm-spaceTop4-DOIZK {
	margin-top: 24px !important;
}

.SiteConfigForm-spaceTop5-EsNmM {
	margin-top: 30px !important;
}

.SiteConfigForm-spaceTop6-hHvow {
	margin-top: 36px !important;
}

.SiteConfigForm-spaceTop7-HzXtW {
	margin-top: 42px !important;
}

.SiteConfigForm-spaceTop8-z0fwZ {
	margin-top: 48px !important;
}

.SiteConfigForm-noMargin-YgEco {
	margin: 0px !important;
}

.SiteConfigForm-padding1-cEAiF {
	padding-bottom: 6px !important;
}

.SiteConfigForm-padding2-LwZgk {
	padding-bottom: 12px !important;
}

.SiteConfigForm-padding3-pU3p4 {
	padding-bottom: 18px !important;
}

.SiteConfigForm-padding4-ttLPW {
	padding-bottom: 24px !important;
}

.SiteConfigForm-padding5-UQRR6 {
	padding-bottom: 30px !important;
}

.SiteConfigForm-padding6-jAaDs {
	padding-bottom: 36px !important;
}

.SiteConfigForm-padding7-OyZd5 {
	padding-bottom: 42px !important;
}

.SiteConfigForm-paddingTop1-SQzbe {
	padding-top: 6px !important;
}

.SiteConfigForm-paddingTop2-pHjm5 {
	padding-top: 12px !important;
}

.SiteConfigForm-paddingTop3-TOJKp {
	padding-top: 18px !important;
}

.SiteConfigForm-paddingTop4-Pju_Q {
	padding-top: 24px !important;
}

.SiteConfigForm-paddingTop5-rIJOh {
	padding-top: 30px !important;
}

.SiteConfigForm-paddingTop6-zulcP {
	padding-top: 36px !important;
}

.SiteConfigForm-paddingTop7-fmCsk {
	padding-top: 42px !important;
}

.SiteConfigForm-noPadding-uVxJt {
	padding: 0px !important;
}

.SiteConfigForm-textBold-ffWQv {
	font-weight: 500 !important;
}

.SiteConfigForm-textBolder-gA4CR {
	font-weight: 700 !important;
}

.SiteConfigForm-textNormal-CuJ0x {
	font-weight: normal !important;
}

.SiteConfigForm-spaceBottom20-AROSA {
	margin-bottom: 20px;
}

.SiteConfigForm-spaceBottom10-X1hu6 {
	margin-bottom: 10px;
}

.SiteConfigForm-marginNone-z3dEr {
	margin: 0;
}

.SiteConfigForm-spaceBottom15-iua3x {
	margin-bottom: 15px;
}

.SiteConfigForm-marginTopNone-PEndm {
	margin-top: 0;
}

.SiteConfigForm-spaceTop11-CCfux {
	margin-top: 11px;
}

.SiteConfigForm-spaceTop21-BCaK_ {
	margin-top: 21px;
}

.SiteConfigForm-spaceTop20-vEsUx {
	margin-top: 20px;
}

.SiteConfigForm-spaceTop10-DsNC_ {
	margin-top: 10px;
}

/*New Design Text Colors */

.SiteConfigForm-textDarkBlue-Lt7AI {
	color: rgb(20, 39, 94) !important;
}

.SiteConfigForm-textLightBlue-caPSE {
	color: rgb(57, 87, 106) !important;
}

.SiteConfigForm-textLightSandleGreen-sKiFe {
	color: rgb(76, 86, 41) !important;
}

.SiteConfigForm-textLightBrown-pduaY {
	color: rgb(115, 79, 33) !important;
}

.SiteConfigForm-textMediumMaroon-owPGh {
	color: rgb(87, 37, 51) !important;
}

.SiteConfigForm-textBrown-NVEe2 {
	color: rgb(160, 47, 24) !important;
}

.SiteConfigForm-textMaroon-mex0K {
	color: rgb(155, 49, 67) !important;
}

.SiteConfigForm-textDarkBrown-ArmQT {
	color: rgb(83, 18, 16) !important;
}

.SiteConfigForm-textMediumBrown-qvOpz {
	color: rgb(142, 28, 10) !important;
}

.SiteConfigForm-textSkyBlue-XL_rj {
	color: rgb(37, 117, 141) !important;
}

.SiteConfigForm-textGray-W7yro {
	color: rgb(77, 65, 51) !important;
}

.SiteConfigForm-girdOne-DYyLr {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    -webkit-column-gap: 22px;
       -moz-column-gap: 22px;
            column-gap: 22px;
}

.SiteConfigForm-girdTwo-PvJu_ {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    -webkit-column-gap: 22px;
       -moz-column-gap: 22px;
            column-gap: 22px;
}

.SiteConfigForm-subHeading-vGRcy{
    font-size: 20px;
    margin-bottom: 18px;
}

.SiteConfigForm-siteConfigSubGridContainer-ZQR8h{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    -webkit-column-gap: 22px;
       -moz-column-gap: 22px;
            column-gap: 22px;
}

.SiteConfigForm-siteConfigSubGridItem-DrhKX{
    grid-column: 1 / span 2;
}

@media screen and (max-width: 1199px) and (min-width: 1024px) {
    .SiteConfigForm-girdOne-DYyLr, .SiteConfigForm-siteConfigSubGridContainer-ZQR8h {
        -webkit-column-gap: 15px;
           -moz-column-gap: 15px;
                column-gap: 15px;
    }

    .SiteConfigForm-girdTwo-PvJu_ {
        grid-template-columns: repeat(2, 1fr);
        -webkit-column-gap: 15px;
           -moz-column-gap: 15px;
                column-gap: 15px;
    }
}

@media screen and (max-width: 767px) {
    .SiteConfigForm-girdOne-DYyLr, .SiteConfigForm-siteConfigSubGridContainer-ZQR8h {
        grid-template-columns: 100%;
    }

    .SiteConfigForm-girdTwo-PvJu_ {
        grid-template-columns: 100%;
    }
    .SiteConfigForm-siteConfigSubGridItem-DrhKX{
        grid-column: 1 / span 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/SiteConfigForm/SiteConfigForm.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;AACA;IACI,uBAAuB;AAC3B;;AACA;IACI;QACI,wBAAgB;WAAhB,qBAAgB;gBAAhB,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;QACrC,wBAAgB;WAAhB,qBAAgB;gBAAhB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;IACA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.girdOne {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 22px;\n}\n\n.girdTwo {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    column-gap: 22px;\n}\n.subHeading{\n    font-size: 20px;\n    margin-bottom: 18px;\n}\n\n.siteConfigSubGridContainer{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 22px;\n}\n.siteConfigSubGridItem{\n    grid-column: 1 / span 2;\n}\n@media screen and (max-width: 1199px) and (min-width: 1024px) {\n    .girdOne, .siteConfigSubGridContainer {\n        column-gap: 15px;\n    }\n\n    .girdTwo {\n        grid-template-columns: repeat(2, 1fr);\n        column-gap: 15px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .girdOne, .siteConfigSubGridContainer {\n        grid-template-columns: 100%;\n    }\n\n    .girdTwo {\n        grid-template-columns: 100%;\n    }\n    .siteConfigSubGridItem{\n        grid-column: 1 / span 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `SiteConfigForm-commonHeaderAdmin-hX8lC`,
	"adminLayout": `SiteConfigForm-adminLayout-K5Fdm`,
	"box": `SiteConfigForm-box-h6Svx`,
	"exportLink": `SiteConfigForm-exportLink-tDDHR`,
	"blockCenter": `SiteConfigForm-blockCenter-SF2mA`,
	"panelHeader": `SiteConfigForm-panelHeader-WyFrY`,
	"currencyselect": `SiteConfigForm-currencyselect-eBU0F`,
	"mar0": `SiteConfigForm-mar0-lqYAz`,
	"sideAdminPageWrapper": `SiteConfigForm-sideAdminPageWrapper-aiNtK`,
	"table": `SiteConfigForm-table-Jp0Vj`,
	"tableRow": `SiteConfigForm-tableRow-SqeNW`,
	"tableCell": `SiteConfigForm-tableCell-QViPt`,
	"formGroup": `SiteConfigForm-formGroup-wRZ3W`,
	"select": `SiteConfigForm-select-tMqVV`,
	"noMargin": `SiteConfigForm-noMargin-YgEco`,
	"labelTextNew": `SiteConfigForm-labelTextNew-wEh3n`,
	"displayInline": `SiteConfigForm-displayInline-Al0vM`,
	"btnUPdate": `SiteConfigForm-btnUPdate-x7B16`,
	"btnModalDelete": `SiteConfigForm-btnModalDelete-r3up9`,
	"radioBtn": `SiteConfigForm-radioBtn-Ikm3Y`,
	"backgroundImg": `SiteConfigForm-backgroundImg-Jv3vA`,
	"btnWidth": `SiteConfigForm-btnWidth-RTQIT`,
	"bannerImageBg": `SiteConfigForm-bannerImageBg-KnsQ_`,
	"bannerDelete": `SiteConfigForm-bannerDelete-wYYk5`,
	"modalRoot": `SiteConfigForm-modalRoot-nuYmE`,
	"modalBorderBottom": `SiteConfigForm-modalBorderBottom-rWCDL`,
	"logInModalBody": `SiteConfigForm-logInModalBody-pTI2T`,
	"exportSection": `SiteConfigForm-exportSection-PccDI`,
	"exportSectionGridSub": `SiteConfigForm-exportSectionGridSub-McLGt`,
	"exportText": `SiteConfigForm-exportText-r9dFn`,
	"exportLinkImg": `SiteConfigForm-exportLinkImg-wPBnr`,
	"vtrMiddle": `SiteConfigForm-vtrMiddle-lh_iI`,
	"exportImg": `SiteConfigForm-exportImg-iPjBx`,
	"profileViewlabel": `SiteConfigForm-profileViewlabel-G7VKe`,
	"profileViewMainContent": `SiteConfigForm-profileViewMainContent-tcfEX`,
	"profileViewMain": `SiteConfigForm-profileViewMain-jOM7x`,
	"profileViewInner": `SiteConfigForm-profileViewInner-Tcql8`,
	"profileImageSection": `SiteConfigForm-profileImageSection-rCJ5C`,
	"lastviewInner": `SiteConfigForm-lastviewInner-eMXPO`,
	"whyHostHoriLine": `SiteConfigForm-whyHostHoriLine-frJxn`,
	"tableGrid": `SiteConfigForm-tableGrid-iQeff`,
	"headingContent": `SiteConfigForm-headingContent-BL73e`,
	"refundTextColor": `SiteConfigForm-refundTextColor-nunXM`,
	"dividerLine": `SiteConfigForm-dividerLine-OdLDp`,
	"smallContent": `SiteConfigForm-smallContent-vS4WV`,
	"ChangeToUpperCase": `SiteConfigForm-ChangeToUpperCase-SvoBs`,
	"noBorder": `SiteConfigForm-noBorder-pN360`,
	"siteAdminHeading": `SiteConfigForm-siteAdminHeading-dQou5`,
	"siteAdminSubHeading": `SiteConfigForm-siteAdminSubHeading-LalRJ`,
	"adminFormDivider": `SiteConfigForm-adminFormDivider-mM4t8`,
	"errorMessage": `SiteConfigForm-errorMessage-mwOyT`,
	"labelText": `SiteConfigForm-labelText-mFZem`,
	"space1": `SiteConfigForm-space1-B6h_o`,
	"space2": `SiteConfigForm-space2-f3YjS`,
	"space3": `SiteConfigForm-space3-fw160`,
	"space4": `SiteConfigForm-space4-EV3OY`,
	"space5": `SiteConfigForm-space5-mVFe4`,
	"space6": `SiteConfigForm-space6-ewCaG`,
	"space7": `SiteConfigForm-space7-gP_pc`,
	"spaceTop8": `SiteConfigForm-spaceTop8-z0fwZ`,
	"spaceTop1": `SiteConfigForm-spaceTop1-ht3f7`,
	"spaceTop2": `SiteConfigForm-spaceTop2-VEK6q`,
	"spaceTop3": `SiteConfigForm-spaceTop3-STmrH`,
	"spaceTop4": `SiteConfigForm-spaceTop4-DOIZK`,
	"spaceTop5": `SiteConfigForm-spaceTop5-EsNmM`,
	"spaceTop6": `SiteConfigForm-spaceTop6-hHvow`,
	"spaceTop7": `SiteConfigForm-spaceTop7-HzXtW`,
	"padding1": `SiteConfigForm-padding1-cEAiF`,
	"padding2": `SiteConfigForm-padding2-LwZgk`,
	"padding3": `SiteConfigForm-padding3-pU3p4`,
	"padding4": `SiteConfigForm-padding4-ttLPW`,
	"padding5": `SiteConfigForm-padding5-UQRR6`,
	"padding6": `SiteConfigForm-padding6-jAaDs`,
	"padding7": `SiteConfigForm-padding7-OyZd5`,
	"paddingTop1": `SiteConfigForm-paddingTop1-SQzbe`,
	"paddingTop2": `SiteConfigForm-paddingTop2-pHjm5`,
	"paddingTop3": `SiteConfigForm-paddingTop3-TOJKp`,
	"paddingTop4": `SiteConfigForm-paddingTop4-Pju_Q`,
	"paddingTop5": `SiteConfigForm-paddingTop5-rIJOh`,
	"paddingTop6": `SiteConfigForm-paddingTop6-zulcP`,
	"paddingTop7": `SiteConfigForm-paddingTop7-fmCsk`,
	"noPadding": `SiteConfigForm-noPadding-uVxJt`,
	"textBold": `SiteConfigForm-textBold-ffWQv`,
	"textBolder": `SiteConfigForm-textBolder-gA4CR`,
	"textNormal": `SiteConfigForm-textNormal-CuJ0x`,
	"spaceBottom20": `SiteConfigForm-spaceBottom20-AROSA`,
	"spaceBottom10": `SiteConfigForm-spaceBottom10-X1hu6`,
	"marginNone": `SiteConfigForm-marginNone-z3dEr`,
	"spaceBottom15": `SiteConfigForm-spaceBottom15-iua3x`,
	"marginTopNone": `SiteConfigForm-marginTopNone-PEndm`,
	"spaceTop11": `SiteConfigForm-spaceTop11-CCfux`,
	"spaceTop21": `SiteConfigForm-spaceTop21-BCaK_`,
	"spaceTop20": `SiteConfigForm-spaceTop20-vEsUx`,
	"spaceTop10": `SiteConfigForm-spaceTop10-DsNC_`,
	"textDarkBlue": `SiteConfigForm-textDarkBlue-Lt7AI`,
	"textLightBlue": `SiteConfigForm-textLightBlue-caPSE`,
	"textLightSandleGreen": `SiteConfigForm-textLightSandleGreen-sKiFe`,
	"textLightBrown": `SiteConfigForm-textLightBrown-pduaY`,
	"textMediumMaroon": `SiteConfigForm-textMediumMaroon-owPGh`,
	"textBrown": `SiteConfigForm-textBrown-NVEe2`,
	"textMaroon": `SiteConfigForm-textMaroon-mex0K`,
	"textDarkBrown": `SiteConfigForm-textDarkBrown-ArmQT`,
	"textMediumBrown": `SiteConfigForm-textMediumBrown-qvOpz`,
	"textSkyBlue": `SiteConfigForm-textSkyBlue-XL_rj`,
	"textGray": `SiteConfigForm-textGray-W7yro`,
	"girdOne": `SiteConfigForm-girdOne-DYyLr`,
	"girdTwo": `SiteConfigForm-girdTwo-PvJu_`,
	"subHeading": `SiteConfigForm-subHeading-vGRcy`,
	"siteConfigSubGridContainer": `SiteConfigForm-siteConfigSubGridContainer-ZQR8h`,
	"siteConfigSubGridItem": `SiteConfigForm-siteConfigSubGridItem-DrhKX`
};
module.exports = ___CSS_LOADER_EXPORT___;
